import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const [data, setData] = useState({
    settings: null, courses: [], gallery: [], events: [], testimonials: [],
  });
  const [loading, setLoading] = useState(true);

  const refresh = () => {
    return Promise.all([
      api.getSettings(), api.getCourses(), api.getGallery(), api.getEvents(), api.getTestimonials(),
    ])
      .then(([settings, courses, gallery, events, testimonials]) =>
        setData({ settings, courses, gallery, events, testimonials })
      )
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    refresh();
  }, []);

  return (
    <ContentContext.Provider value={{ ...data, loading, refresh }}>
      {children}
    </ContentContext.Provider>
  );
}

export const useContent = () => useContext(ContentContext);
